import { createFileRoute } from "@tanstack/react-router";

import { SiteAccessPanel } from "../features/siteAccess/SiteAccessPanel";

export const Route = createFileRoute(
  "/accounts/$accountSlug/tenants/$tenantSlug/sites/$siteSlug/access",
)({
  component: AccessRoute,
});

function AccessRoute() {
  const { accountSlug, siteSlug } = Route.useParams();
  return <SiteAccessPanel accountSlug={accountSlug} siteSlug={siteSlug} />;
}
